import { render, staticRenderFns } from "./SimpleAgreement.vue?vue&type=template&id=73781883&scoped=true"
import script from "./SimpleAgreement.vue?vue&type=script&lang=js"
export * from "./SimpleAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73781883",
  null
  
)

export default component.exports